import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Select from '@material-ui/core/Select';
import Slider from '@material-ui/core/Slider';
import { makeStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Tabs from '@material-ui/core/Tabs';
import TextField from '@material-ui/core/TextField';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import TextsmsIcon from '@material-ui/icons/Textsms';
import parsePhoneNumber from 'libphonenumber-js/max';
import React, { useEffect, useState } from 'react';
import Flag from 'react-world-flags';
import usePortalAuth from '../../../auth/usePortalAuth';
import basePCUrl from '../../../Globals';

import useChangePageTitle from '../CustomHooks/useChangePageTitle';
//import codes from 'country-calling-code';
import './Configuration.css';
import { TabPanel } from './TabPanel';
import AdminMessageForm from '../AdminMessages/AdminMessageForm';

const CompanyConfiguration = (props) => {
  useChangePageTitle('AdminConfiguration');

  const adminConfigData = props.adminConfigData
  const preferredLanguage = props.preferredLanguage
  const getTranslation = props.getTranslation

  const [state, setState] = React.useState({
    sliderValue: [0, 100],
    slider: false,
    email: false,
    emailList: [],
    emailSeverityThreshold: 'high',
    SMS: false,
    SMSList: [],
    SMSSeverityThreshold: 'high',
    clientName: null,
    clientLogo: null,
  });

  const [trainingState, setTrainingState] = useState({
    trainingFlag: false,
    videoType: null,
    frequency: null,
    completionIndicator: null,
    video: false,
    pdf: false,
    quiz: false,
    yellowClick: false,
    redClick: false,
  });

  const [extraEmailInputs, setExtraEmailInputs] = useState([]);
  const [phoneInputs, setPhoneInputs] = useState([]);
  const [extraPhoneInputs, setExtraPhoneInputs] = useState([]);
  const [countryCodes, setCountryCodes] = useState([]);

  const [currentEmails, setCurrentEmails] = useState([]);
  const [emailInputs, setEmailInputs] = useState([]);
  const [currentPhoneNumbers, setCurrentPhoneNumbers] = useState([]);
  const [isLoading, setIsLoading] = useState();
  const [isLoadingTraining, setIsLoadingTraining] = useState();

  const { getAccessTokenSilently } = usePortalAuth();

  if (props.selectedClient.clientId === undefined || props.selectedClient.clientId === '') {
    var clientId = props.defaultClient;
  } else {
    var clientId = props.selectedClient.clientId;
  }

  const trainingPush = () => {
    props.history.push('/Dashboard/TrainingSuite');

    window.scrollTo(0, 0);
  };
  //get admin config data

  // const adminConfigData = useQuery('admin-data', async () => {
  //   const token = await getAccessTokenSilently();
  //   return fetchApiData(basePCUrl, token, 'adminConfigs','AccountAdmin',clientId);
  // });

  // console.log("adminConfig",adminConfigData,props)

  const getAdminConfigSettings = async () => {
    const token = await getAccessTokenSilently();
    return new Promise(async (resolve, reject) => {
      setIsLoadingTraining(true);
      setIsLoading(true);

      fetch(basePCUrl, {
        method: 'get',
        headers: {
          Action: 'adminConfigs',
          id: clientId,
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }

          response.json().then((data) => {
            resolve(data);
            setState({
              sliderValue: [
                data.settings.ClientSafetyParameters.lowerSafetyLimit,
                data.settings.ClientSafetyParameters.upperSafetyLimit,
              ],
              slider: data.settings.ClientSafetyParameters.Enabled,
              email: data.settings.AlertSettings.AlertEmailSettings.Enabled,
              initialEmailList: data.settings.AlertSettings.AlertEmailSettings.Emails,
              emailSeverityThreshold: data.settings.AlertSettings.AlertEmailSettings.SeverityThreshold,
              SMS: data.settings.AlertSettings.alertSMSSettings.Enabled,
              SMSList: data.settings.AlertSettings.alertSMSSettings.PhoneNumbers,
              SMSSeverityThreshold: data.settings.AlertSettings.alertSMSSettings.SeverityThreshold,
              clientName: data.clientInfo.clientName,
              clientLogo: data.clientInfo.clientLogo,
            });
            setCurrentEmails(data.settings.AlertSettings.AlertEmailSettings.Emails);
            setCurrentPhoneNumbers(data.settings.AlertSettings.alertSMSSettings.PhoneNumbers);
            setIsLoading(false);

            setTrainingState({
              trainingFlag: data.settings.trainingSettings.trainingFlag,
              videoType: data.settings.trainingSettings.videoType,
              frequency: data.settings.trainingSettings.trainingFrequency,
              completionIndicator: data.settings.trainingSettings.completionIndicator,
              yellowClick: data.settings.trainingSettings.ongoingTraining.yellowClick,
              redClick: data.settings.trainingSettings.ongoingTraining.redClick,
            });
            setIsLoadingTraining(false);

            //console.log(data)
          });
        })
        .catch(function (err) {
          console.log('Fetch Error :-S', err);
        });
    });
  };

  useEffect(() => {
    getAdminConfigSettings();
  }, []);

  //add country codes to phone numbers retrieved on page load
  if (extraPhoneInputs != undefined) {
    for (var i = 0; i < extraPhoneInputs.length; i++) {
      if (extraPhoneInputs[i].phoneNumber.startsWith('+1')) {
        extraPhoneInputs[i].countryCode = '+1';
      } else if (extraPhoneInputs[i].phoneNumber.startsWith('+81')) {
        extraPhoneInputs[i].countryCode = '+81';
      } else if (extraPhoneInputs[i].phoneNumber.startsWith('+44')) {
        extraPhoneInputs[i].countryCode = '+44';
      } else if (extraPhoneInputs[i].phoneNumber.startsWith('+90')) {
        extraPhoneInputs[i].countryCode = '+90';
      }
    }
  }

  const handleSubmitWithTraining = async (event) => {
    event.preventDefault();

    const token = await getAccessTokenSilently();
    if (props.accessLevel != undefined) {
      var data = {
        clientId: clientId,
        settings: {
          trainingSettings: {
            trainingFlag: trainingFlag,
            trainingFrequency: frequency,
            startDate: 'hardCoded',
            completionIndicator: completionIndicator,
            videoType: videoType,
            ongoingTraining: {
              yellowClick: yellowClick,
              redClick: redClick,
            },
          },
          clientSafetyParameters: {
            enabled: slider,
            upperSafetyLimit: sliderValue[0],
            lowerSafetyLimit: sliderValue[1],
          },
          alertSettings: {
            alertEmailSettings: {
              severityThreshold: emailSeverityThreshold,
              emails: FinalEmailListObject,
              enabled: email,
            },
            alertSMSSettings: {
              severityThreshold: SMSSeverityThreshold,
              phoneNumbers: FinalPhoneListObject,
              enabled: SMS,
            },
          },
          customLandingPageUnknown: null,
          customLandingPageUnsafe: null,
          clientLogo,
          clientName,
        },
      };

      if (emailErrorCheck === true) {
        ShowErrorMessage('Invalid Email');
      } else if (phoneErrorCheck === true) {
        ShowErrorMessage('Invalid Phone Number');
      } else {
        fetch(basePCUrl, {
          method: 'post',
          body: JSON.stringify(data),
          headers: {
            id: clientId,
            Authorization: `Bearer ${token}`,
            Action: 'updateAdminSettings',
            'Content-Type': 'application/json',
          },
        })
          .then((response) => {
            if (response.status != 200) {
              console.log(
                'Looks like there was a problem. Status Code: ' +
                  response.status +
                  '\nStatus details: ' +
                  response.content
              );
              return;
            } else {
              // console.log('Success! Status Code: ' +
              //     response.status);
              //ShowSuccessMessage('Settings Saved');
              //console.log(response)
              return;
            }
          })
          .catch(function (err) {
            console.log('Fetch Error :-S', err);
          });
      }
    }
  };

  //-------Settings Saved Message------//
  const ShowSuccessMessage = (msg) => {
    let x = document.getElementById('snackbar');
    x.innerHTML = msg;
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  };

  const ShowErrorMessage = (msg) => {
    let x = document.getElementById('errorSnackbar');
    x.innerHTML = msg;
    x.className = 'show';
    setTimeout(function () {
      x.className = x.className.replace('show', '');
    }, 3000);
  };

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  const handleTrainingChange = (event) => {
    setTrainingState({ ...trainingState, [event.target.name]: event.target.checked });
  };

  const handleRadioChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value });
  };

  const handleTrainingRadioChange = (event) => {
    setTrainingState({ ...trainingState, [event.target.name]: event.target.value });
  };
  const [value, setValue] = React.useState(0);

  const handleChangeTab = (event, newValue) => {
    setValue(newValue);
  };
  const {
    slider,
    sliderValue,
    email,
    emailList,
    emailSeverityThreshold,
    SMS,
    SMSList,
    SMSSeverityThreshold,
    clientName,
    clientLogo,
  } = state;

  const { trainingFlag, videoType, frequency, completionIndicator, video, pdf, quiz, yellowClick, redClick } =
    trainingState;

  /////----------Email Logic-------------/////

  let emailCheck =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  //-------Handle textfiled onChange--------//
  const handleEmailListChange = (i, event) => {
    if (event.target.name === 'uE' && event.target.value.match(emailCheck)) {
      const values = [...extraEmailInputs];
      values[i].email = event.target.value;
      values[i].errorValue = false;
      values[i].errorTextEmail = '';
      setExtraEmailInputs(values);
    } else if (event.target.name === 'uE') {
      const values = [...extraEmailInputs];
      values[i].email = event.target.value;
      values[i].errorValue = true;
      values[i].errorTextEmail = 'Invalid email';
      setExtraEmailInputs(values);
    } else if (event.target.name === 'usersName') {
      const values = [...extraEmailInputs];
      values[i].name = event.target.value;
      setExtraEmailInputs(values);
    }
  };

  //-----Add new email text field-----//
  const handleEmailListAdd = () => {
    const values = [...extraEmailInputs];
    values.push({ email: '', name: '', errorValue: false, errorTextEmail: '' });
    setExtraEmailInputs(values);
  };

  //-----Remove email text field-----//
  const handleEmailListRemove = (i) => {
    const values = [...extraEmailInputs];
    values.splice(i, 1);
    setExtraEmailInputs(values);
  };

  //-----Only names and emails for updateClientSettings API call-----//
  let emailListObject = extraEmailInputs.map((emails) => ({
    name: emails.name,
    email: emails.email,
  }));

  let FinalEmailListObject = emailListObject.concat(currentEmails);

  //-------Only error Status for error message/submission prevention-------//
  let onlyEmailErrorObject = extraEmailInputs.map((emails) => ({
    error: emails.errorTextEmail,
  }));

  const emailErrorCheck = onlyEmailErrorObject.some((el) => el.error === 'Invalid email');

  //-------Handle Email Table Row Delete------//
  const handleEmailTableRowRemove = (i) => {
    const values = [...currentEmails];
    values.splice(i, 1);
    setCurrentEmails(values);
  };

  //--------Existing Emails Table-------//

  const ExistingEmailsTable = () => {
    const emailRows = currentEmails;

    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

    if (currentEmails && currentEmails.length) {
      return (
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table
            stickyHeader
            size="medium"
            aria-label="list of current emails for alert notifications"
          >
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell align="left">
                {getTranslation("Name", preferredLanguage)}
                </TableCell>
                <TableCell align="left">
                {getTranslation("Email", preferredLanguage)}
                </TableCell>
                <TableCell align="right">
                  {getTranslation("Delete", preferredLanguage)}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {emailRows.map((row, idx) => (
                <TableRow key={`${row}-${idx}`} hover>
                  <TableCell align="left">
                    {row.name}
                  </TableCell>
                  <TableCell align="left">{row.email}</TableCell>
                  <TableCell align="right">
                    <IconButton type="button" edge="end" onClick={() => handleEmailTableRowRemove(idx)}>
                      <HighlightOffIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={emailRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TableContainer>
      );
    } else if (currentEmails.length === 0) {
      return <span></span>;
    }
  };

  /////----------SMS/Phone Logic-------------/////

  const handlePhoneListChange = (i, event) => {
    //create a copy of the existing phoneNumber data for editing/working with
    const values = [...extraPhoneInputs];

    //For changing the country code input
    if (event.target.name === 'countryCode') {
      //const values = [...extraPhoneInputs];
      values[i].countryCode = event.target.value;

      //Check the number in the phone number field every time the country code is changed
      let recheckPhoneNumber = parsePhoneNumber(event.target.value + values[i].phoneNumber);
      if (recheckPhoneNumber != undefined && !recheckPhoneNumber.isValid()) {
        values[i].errorValue = true;
        values[i].errorTextPhone = 'Invalid phone number';
      } else {
        values[i].errorValue = false;
        values[i].errorTextPhone = '';
      }

      setExtraPhoneInputs(values);
    }

    //For changing the phone number input
    if (
      event.target.value != undefined &&
      event.target.value != null &&
      event.target.value != ' ' &&
      event.target.name === 'phoneNumber' &&
      values[i].countryCode != undefined
    ) {
      //use the phone validation library to parse the entered country code and phone number for validation
      let enteredPhoneNumber = parsePhoneNumber(values[i].countryCode + event.target.value);

      if (enteredPhoneNumber != undefined && enteredPhoneNumber.isValid()) {
        //check if the phone number is valid and then set the values for that field set

        values[i].phoneNumber = event.target.value;
        values[i].errorValue = false;
        values[i].errorTextPhone = '';
        setExtraPhoneInputs(values);
      } else {
        //handle if the phone number is not valid - set error true and error message

        values[i].phoneNumber = event.target.value;
        values[i].errorValue = true;
        values[i].errorTextPhone = 'Invalid phone number';
        setExtraPhoneInputs(values);
      }
    } else if (event.target.name === 'usersName') {
      //handle the user's name input and set the values for that field set

      values[i].name = event.target.value;

      setExtraPhoneInputs(values);
    }
  };

  //-----Add new phone text field-----//
  const handlePhoneListAdd = () => {
    const values = [...extraPhoneInputs];
    values.push({ phoneNumber: '', name: '', countryCode: '', errorValue: false, errorTextPhone: '' });
    setExtraPhoneInputs(values);
  };

  //-----Remove phone text field-----//
  const handlePhoneListRemove = (i) => {
    const values = [...extraPhoneInputs];
    values.splice(i, 1);
    setExtraPhoneInputs(values);
  };

  //-----Only phone Numbers for updateClientSettings API call-----//
  let PhoneListObject = extraPhoneInputs.map((phoneNumbers) => ({
    name: phoneNumbers.name,
    phoneNumber: phoneNumbers.phoneNumber.startsWith('+')
      ? phoneNumbers.phoneNumber
      : phoneNumbers.countryCode + phoneNumbers.phoneNumber.replace(/-/g, '').split(' ').join(''),
  }));

  let FinalPhoneListObject = PhoneListObject.concat(currentPhoneNumbers);

  //console.log(FinalPhoneListObject)

  //-------Only error Status for error message/submission prevention-------//
  let onlyPhoneErrorObject = extraPhoneInputs.map((phoneNumbers) => ({
    error: phoneNumbers.errorTextPhone,
  }));

  const phoneErrorCheck = onlyPhoneErrorObject.some((el) => el.error === 'Invalid phone number');

  const useStyles = makeStyles((theme) => ({
    root: {
      padding: theme.spacing(3),
      background: theme.palette.type === 'dark' ? theme.palette.background.default : 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      minHeight: '100vh',
    },
    header: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginBottom: theme.spacing(4),
    },
  pageTitle: {
      fontWeight: 700,
      color: theme.palette.type === 'dark' ? theme.palette.text.primary : '#1a237e',
      marginBottom: theme.spacing(1),
      fontFamily: 'Montserrat, sans-serif',
    },
    applyButton: {
      backgroundColor: '#0055A2',
      color: 'white',
      fontWeight: 600,
      padding: theme.spacing(1, 4),
      borderRadius: 8,
      '&:hover': {
        backgroundColor: '#061739',
      },
    },
    tabsContainer: {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      border: '1px solid rgba(255,255,255,0.2)',
      marginBottom: theme.spacing(3),
      overflow: 'hidden',
    },
    tabs: {
      background: 'linear-gradient(135deg, #061739 0%, #0055A2 50%, #428BC9 100%)',
      '& .MuiTab-root': {
        color: 'rgba(255,255,255,0.7)',
        fontWeight: 600,
        fontSize: '0.95rem',
        textTransform: 'none',
        minHeight: 56,
      },
      '& .Mui-selected': {
        color: '#fff',
      },
      '& .MuiTabs-indicator': {
        backgroundColor: '#fff',
        height: 3,
      },
    },
    sectionCard: {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 16,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
      padding: theme.spacing(3),
      marginBottom: theme.spacing(3),
      transition: 'all 0.3s ease-in-out',
      '&:hover': {
        boxShadow: '0 12px 40px 0 rgba(31, 38, 135, 0.2)',
      },
    },
    sectionTitle: {
      fontSize: '1.3rem',
      fontWeight: 700,
      color: '#0055A2',
      marginBottom: theme.spacing(2),
      fontFamily: 'Montserrat, sans-serif',
    },
    sectionSubtitle: {
      color: '#546e7a',
      marginBottom: theme.spacing(2),
    },
    title: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      color: '#0055A2',
      flex: '1 1 100%',
    },
    tableContainer: {
      background: theme.palette.type === 'dark' ? theme.palette.background.paper : 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderRadius: 12,
      border: '1px solid rgba(255, 255, 255, 0.2)',
      boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
    tableHead: {
      background: 'linear-gradient(135deg, #061739 0%, #0055A2 50%, #428BC9 100%)',
      '& .MuiTableCell-head': {
        color: 'white',
        fontWeight: 600,
      },
    },
    formRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
      flexWrap: 'wrap',
      marginBottom: theme.spacing(2),
    },
    addButton: {
      backgroundColor: '#0055A2',
      color: 'white',
      borderRadius: 8,
      '&:hover': {
        backgroundColor: '#061739',
      },
    },
    trainingButton: {
      backgroundColor: '#0055A2',
      color: 'white',
      fontWeight: 600,
      borderRadius: 8,
      '&:hover': {
        backgroundColor: '#061739',
      },
    },
    confidenceDescription: {
      color: theme.palette.type === 'dark' ? theme.palette.text.secondary : '#546e7a',
      fontSize: '0.9rem',
      marginBottom: theme.spacing(2),
      lineHeight: 1.6,
    },
    confidenceSlider: {
      color: theme.palette.type === 'dark' ? '#90caf9' : '#0055A2',
      height: 8,
      '& .MuiSlider-thumb': {
        height: 22,
        width: 22,
        backgroundColor: theme.palette.type === 'dark' ? '#90caf9' : '#fff',
        border: theme.palette.type === 'dark' ? '3px solid #90caf9' : '3px solid #0055A2',
        marginTop: -7,
        marginLeft: -11,
        boxShadow: theme.palette.type === 'dark' ? '0 2px 8px rgba(144,202,249,0.4)' : '0 2px 8px rgba(0,85,162,0.25)',
        '&:focus, &:hover, &$active': {
          boxShadow: theme.palette.type === 'dark' ? '0 3px 12px rgba(144,202,249,0.5)' : '0 3px 12px rgba(0,85,162,0.4)',
        },
      },
      '& .MuiSlider-track': {
        height: 8,
        borderRadius: 4,
      },
      '& .MuiSlider-rail': {
        height: '8px !important',
        borderRadius: 4,
        opacity: '1 !important',
        backgroundColor: theme.palette.type === 'dark' ? '#666 !important' : 'rgba(144,164,174,0.3) !important',
      },
      '& .MuiSlider-valueLabel': {
        color: theme.palette.type === 'dark' ? '#000 !important' : '#fff !important',
        '& *': {
          background: theme.palette.type === 'dark' ? '#90caf9 !important' : '#0055A2 !important',
          color: theme.palette.type === 'dark' ? '#000 !important' : '#fff !important',
        },
      },
    },
    sliderInputRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(2),
    },
    sliderInputField: {
      width: 88,
      '& .MuiOutlinedInput-root': {
        color: theme.palette.text.primary,
        '& .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.23)',
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: theme.palette.type === 'dark' ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.87)',
        },
      },
      '& .MuiInputLabel-root': {
        color: theme.palette.text.secondary,
      },
      '& .MuiOutlinedInput-input': {
        padding: '10px 12px',
        textAlign: 'center',
        fontWeight: 600,
        fontSize: '0.95rem',
      },
    },
    zoneBar: {
      display: 'flex',
      height: 8,
      borderRadius: 4,
      overflow: 'hidden',
      marginTop: theme.spacing(2),
    },
    zoneLegend: {
      display: 'flex',
      justifyContent: 'center',
      gap: theme.spacing(3),
      marginTop: theme.spacing(1.5),
      flexWrap: 'wrap',
    },
    zoneLegendItem: {
      display: 'flex',
      alignItems: 'center',
      gap: 6,
    },
    zoneDot: {
      width: 10,
      height: 10,
      borderRadius: '50%',
      display: 'inline-block',
    },
  }));

  function AirbnbThumbComponent(props) {
    return <span {...props} />;
  }

  const classes = useStyles();

  //--------Handle slider change-------//
  const handleSliderChange = (event, newValue) => {
    setState({ ...state, sliderValue: newValue });
  };

  //--------Handle slider numeric input change-------//
  const handleSliderInputChange = (index, value) => {
    const newValue = [...sliderValue];
    const numValue = Math.min(100, Math.max(0, Number(value) || 0));
    newValue[index] = numValue;
    if (index === 0 && numValue > newValue[1]) newValue[1] = numValue;
    if (index === 1 && numValue < newValue[0]) newValue[0] = numValue;
    setState({ ...state, sliderValue: newValue });
  };

  //-------Handle Table Row Delete------//
  const handlePhoneTableRowRemove = (i) => {
    const values = [...currentPhoneNumbers];
    values.splice(i, 1);
    setCurrentPhoneNumbers(values);
  };

  //--------Existing Phone Numbers Table-------//

  const rows = currentPhoneNumbers;

  const ExistingPhoneNumbersTable = () => {
    const classes = useStyles();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const handleChangePage = (event, newPage) => {
      setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
      setRowsPerPage(+event.target.value);
      setPage(0);
    };

    if (currentPhoneNumbers && currentPhoneNumbers.length) {
      return (
        <TableContainer component={Paper} className={classes.tableContainer}>
          <Table
            stickyHeader
            size="medium"
            aria-label="list of current phone numbers for alert notifications"
          >
            <TableHead className={classes.tableHead}>
              <TableRow>
                <TableCell align="left">
                {getTranslation("Name", preferredLanguage)}
                </TableCell>
                <TableCell align="left">
                {getTranslation("Phone Number", preferredLanguage)}
                </TableCell>
                <TableCell align="right">
                {getTranslation("Delete", preferredLanguage)}
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row, idx) => (
                <TableRow key={`${row}-${idx}`} hover>
                  <TableCell align="left">
                    {row.name}
                  </TableCell>
                  <TableCell align="left">{row.phonenumber}</TableCell>
                  <TableCell align="right">
                    <IconButton type="button" edge="end" onClick={() => handlePhoneTableRowRemove(idx)}>
                      <HighlightOffIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[10, 25, 100]}
            component="div"
            count={rows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
        </TableContainer>
      );
    } else if (currentPhoneNumbers.length === 0) {
      return <span></span>;
    }
  };

  const TitleToolbarWithButton = (props) => {
    return (
      <Toolbar>
        <Typography className={classes.title} variant="h6" gutterBottom id="settingsTitle">
          {props.title}
        </Typography>

        <Button type="submit" variant="contained" color="primary" style={{ marginLeft: '15px' }}>
          {getTranslation('Apply Settings', props.preferredLanguage)}
        </Button>
      </Toolbar>
    );
  };
  
  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  return (
    <div className={classes.root}>
      {isLoading}
      <form onSubmit={handleSubmitWithTraining} autoComplete="off">
        {/* Header */}
        <Box className={classes.header}>
          <Typography variant="h3" className={classes.pageTitle}>
            {getTranslation("Admin Tools", preferredLanguage)}
          </Typography>
          <Box mt={2}>
            <Button type="submit" className={classes.applyButton}>
              {getTranslation("Apply Settings", preferredLanguage)}
            </Button>
          </Box>
        </Box>

        {/* Tabs */}
        <Paper className={classes.tabsContainer}>
          <Tabs
            value={value}
            onChange={handleChangeTab}
            className={classes.tabs}
            aria-label="admin configuration tabs"
          >
            <Tab label={getTranslation("General", preferredLanguage)} {...a11yProps(0)} />
            <Tab label={getTranslation("Notification", preferredLanguage)} {...a11yProps(1)} />
            <Tab label={getTranslation("Training", preferredLanguage)} {...a11yProps(2)} />
          </Tabs>
        </Paper>

        {/* General Tab */}
        <TabPanel value={value} index={0}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper className={classes.sectionCard}>
                <Typography className={classes.sectionTitle}>
                  {getTranslation("Confidence Level", preferredLanguage)}
                </Typography>
                {/* <Typography className={classes.confidenceDescription}>
                  {getTranslation("Set the confidence thresholds that determine how links are classified. Links scoring below the lower bound are flagged as unsafe, between the bounds as caution, and above the upper bound as safe.", preferredLanguage)}
                </Typography> */}
                <FormGroup>
                  <FormControlLabel
                    style={{ paddingBottom: '12px' }}
                    control={<Switch color="primary" checked={slider} onChange={handleChange} name="slider" />}
                    label={getTranslation("Manually set Confidence Level", preferredLanguage)}
                  />
                  <Box className={classes.sliderInputRow} mt={2} mb={1}>
                    <TextField
                      label={getTranslation("Lower", preferredLanguage)}
                      variant="outlined"
                      size="small"
                      type="number"
                      value={sliderValue[0]}
                      onChange={(e) => handleSliderInputChange(0, e.target.value)}
                      disabled={!slider}
                      className={classes.sliderInputField}
                      inputProps={{ min: 0, max: 100 }}
                    />
                    <Box style={{ flex: 1 }}>
                      <Slider
                        value={sliderValue}
                        onChange={handleSliderChange}
                        className={classes.confidenceSlider}
                        valueLabelDisplay="auto"
                        getAriaLabel={(index) => (index === 0 ? 'Minimum confidence level' : 'Maximum confidence level')}
                        disabled={!slider}
                        min={0}
                        max={100}
                      />
                      <Box display="flex" justifyContent="space-between" style={{ marginTop: -4 }}>
                        <Typography variant="caption" style={{ color: '#90a4ae', fontWeight: 500 }}>0</Typography>
                        <Typography variant="caption" style={{ color: '#90a4ae', fontWeight: 500 }}>100</Typography>
                      </Box>
                    </Box>
                    <TextField
                      label={getTranslation("Upper", preferredLanguage)}
                      variant="outlined"
                      size="small"
                      type="number"
                      value={sliderValue[1]}
                      onChange={(e) => handleSliderInputChange(1, e.target.value)}
                      disabled={!slider}
                      className={classes.sliderInputField}
                      inputProps={{ min: 0, max: 100 }}
                    />
                  </Box>
                  {/* <Box className={classes.zoneBar}>
                    <div style={{ width: `${sliderValue[0]}%`, backgroundColor: '#ef5350', transition: 'width 0.2s' }} />
                    <div style={{ width: `${sliderValue[1] - sliderValue[0]}%`, backgroundColor: '#ffa726', transition: 'width 0.2s' }} />
                    <div style={{ width: `${100 - sliderValue[1]}%`, backgroundColor: '#66bb6a', transition: 'width 0.2s' }} />
                  </Box> */}
                  {/* <Box className={classes.zoneLegend}>
                    <Box className={classes.zoneLegendItem}>
                      <span className={classes.zoneDot} style={{ backgroundColor: '#ef5350' }} />
                      <Typography variant="caption" style={{ fontWeight: 600, color: '#ef5350' }}>
                        {getTranslation("Unsafe", preferredLanguage)} (0–{sliderValue[0]})
                      </Typography>
                    </Box>
                    <Box className={classes.zoneLegendItem}>
                      <span className={classes.zoneDot} style={{ backgroundColor: '#ffa726' }} />
                      <Typography variant="caption" style={{ fontWeight: 600, color: '#ffa726' }}>
                        {getTranslation("Caution", preferredLanguage)} ({sliderValue[0]}–{sliderValue[1]})
                      </Typography>
                    </Box>
                    <Box className={classes.zoneLegendItem}>
                      <span className={classes.zoneDot} style={{ backgroundColor: '#66bb6a' }} />
                      <Typography variant="caption" style={{ fontWeight: 600, color: '#66bb6a' }}>
                        {getTranslation("Safe", preferredLanguage)} ({sliderValue[1]}–100)
                      </Typography>
                    </Box>
                  </Box> */}
                </FormGroup>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Paper className={classes.sectionCard}>
                <Typography className={classes.sectionTitle}>
                  {getTranslation("Admin Messaging", preferredLanguage)}
                </Typography>
                <AdminMessageForm portalKeyData={props.portalKeyData} preferredLanguage={preferredLanguage} getTranslation={getTranslation} />
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Notification Tab */}
        <TabPanel value={value} index={1}>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper className={classes.sectionCard}>
                <Typography className={classes.sectionTitle}>
                  {getTranslation("Alerts", preferredLanguage)}
                </Typography>
                <Typography variant="body1" className={classes.sectionSubtitle}>
                  {getTranslation("How would you like to receive alert notifications?", preferredLanguage)}
                </Typography>

                {/* Email Alerts Section */}
                <Box mb={3}>
                  <Box className={classes.formRow}>
                    <FormControlLabel
                      control={<Switch color="primary" checked={email} onChange={handleChange} name="email" />}
                      label={getTranslation("Email Alerts", preferredLanguage)}
                    />
                    <Button
                      type="button"
                      disabled={!email}
                      onClick={() => handleEmailListAdd()}
                      className={classes.addButton}
                      style={{ height: '48px', minWidth: '48px' }}
                    >
                      <PersonAddIcon />
                    </Button>
                  </Box>

                  {extraEmailInputs.map((field, idx) => {
                    return (
                      <div key={`${field}-${idx}`} style={{ padding: '10px', width: '100%' }}>
                        <TextField
                          required
                          disabled={!email}
                          placeholder="Name"
                          value={field.name}
                          label={getTranslation("Name", preferredLanguage)}
                          name="usersName"
                          variant="outlined"
                          autoComplete="off"
                          style={{
                            maxWidth: 400,
                            minWidth: 170,
                            width: '45%',
                            paddingRight: '0px',
                            marginRight: '10px',
                            marginBottom: '15px',
                          }}
                          onChange={(e) => handleEmailListChange(idx, e)}
                          InputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                        />
                        <TextField
                          required
                          disabled={!email}
                          error={field.errorValue}
                          helperText={field.errorTextEmail}
                          placeholder="Email"
                          value={field.email}
                          label={getTranslation("Email", preferredLanguage)}
                          name="uE"
                          variant="outlined"
                          autoComplete="off"
                          style={{ maxWidth: 400, minWidth: 170, width: '45%', paddingRight: '0px' }}
                          onChange={(e) => handleEmailListChange(idx, e)}
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end" style={{ paddingRight: '0px' }}>
                                <IconButton type="button" edge="end" onClick={() => handleEmailListRemove(idx)}>
                                  <HighlightOffIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                        />
                      </div>
                    );
                  })}

                  {email && currentEmails.length ? <ExistingEmailsTable /> : null}

                  <Box mt={2}>
                    <Typography variant="subtitle2" className={classes.sectionSubtitle}>
                      {getTranslation("For what severity level(s)?")}
                    </Typography>
                    <RadioGroup
                      aria-label="email alert severity threshold"
                      row
                      name="emailSeverityThreshold"
                      value={emailSeverityThreshold}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel
                        value="high"
                        control={<Radio color="primary" disabled={!email} />}
                        label={getTranslation("Only High", preferredLanguage)}
                      />
                      <FormControlLabel
                        value="medium"
                        control={<Radio color="primary" disabled={!email} />}
                        label={getTranslation("High & Medium", preferredLanguage)}
                      />
                      <FormControlLabel value="all" control={<Radio color="primary" disabled={!email} />} label={getTranslation("All", preferredLanguage)} />
                    </RadioGroup>
                  </Box>
                </Box>

                {/* SMS Alerts Section */}
                <Box mt={3}>
                  <Box className={classes.formRow}>
                    <FormControlLabel
                      control={<Switch color="primary" checked={SMS} onChange={handleChange} name="SMS" />}
                      label={getTranslation("SMS Alerts", preferredLanguage)}
                    />
                    <Button
                      type="button"
                      disabled={!SMS}
                      onClick={() => handlePhoneListAdd()}
                      className={classes.addButton}
                      style={{ height: '48px' }}
                    >
                      <b>+</b>
                      <TextsmsIcon style={{ marginLeft: '4px' }} />
                    </Button>
                  </Box>

                  {extraPhoneInputs.map((field, idx) => {
                    return (
                      <div key={`${field}-${idx}`} style={{ padding: '10px', width: '100%' }}>
                        <TextField
                          required
                          disabled={!SMS}
                          placeholder={getTranslation("Enter text", preferredLanguage)}
                          value={field.name}
                          label={getTranslation("Name", preferredLanguage)}
                          name="usersName"
                          variant="outlined"
                          autoComplete="off"
                          style={{
                            maxWidth: 400,
                            minWidth: 280,
                            width: '45%',
                            paddingRight: '0px',
                            marginRight: '10px',
                            marginBottom: '15px',
                          }}
                          onChange={(e) => handlePhoneListChange(idx, e)}
                          InputProps={{
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                        />

                        <br />

                        <TextField
                          disabled={!SMS}
                          required
                          error={field.errorValue}
                          helperText={field.errorTextPhone}
                          placeholder={getTranslation("Enter text", preferredLanguage)}
                          value={field.phoneNumber}
                          label={getTranslation("Phone", preferredLanguage)}
                          name="phoneNumber"
                          variant="outlined"
                          autoComplete="off"
                          style={{
                            marginLeft: 0,
                            maxWidth: 400,
                            minWidth: 280,
                            width: '45%',
                            paddingRight: '0px',
                            height: '59px',
                          }}
                          onChange={(e) => handlePhoneListChange(idx, e)}
                          InputProps={{
                            startAdornment: (
                              <FormControl required style={{ marginRight: 70 }}>
                                <Select
                                  required
                                  labelId="County Calling Code"
                                  name="countryCode"
                                  value={field.countryCode}
                                  onChange={(e) => handlePhoneListChange(idx, e)}
                                  label={getTranslation("Country Code", preferredLanguage)}
                                  defaultValue={field.countryCode}
                                  style={{ marginRight: 0, paddingRight: 0, width: '90px' }}
                                >
                                  <MenuItem value={'+' + 1}>
                                    <Flag code="US" height="15" style={{ paddingRight: '5px' }} />
                                    US
                                  </MenuItem>
                                  <MenuItem value={'+' + 44}>
                                    <Flag code="GB" height="15" style={{ paddingRight: '5px' }} />
                                    UK
                                  </MenuItem>
                                  <MenuItem value={'+' + 81}>
                                    <Flag code="JP" height="15" style={{ paddingRight: '5px' }} />
                                    JP
                                  </MenuItem>
                                  <MenuItem value={'+' + 90}>
                                    <Flag code="TR" height="15" style={{ paddingRight: '5px' }} />
                                    TR
                                  </MenuItem>
                                </Select>
                              </FormControl>
                            ),
                            endAdornment: (
                              <InputAdornment position="end" style={{ paddingRight: '0px' }}>
                                <IconButton type="button" edge="end" onClick={() => handlePhoneListRemove(idx)}>
                                  <HighlightOffIcon />
                                </IconButton>
                              </InputAdornment>
                            ),
                            form: {
                              autocomplete: 'off',
                            },
                          }}
                        />
                      </div>
                    );
                  })}

                  {SMS && currentPhoneNumbers != undefined ? <ExistingPhoneNumbersTable /> : null}

                  <Box mt={2}>
                    <Typography variant="subtitle2" className={classes.sectionSubtitle}>
                      {getTranslation("For what severity level(s)?", preferredLanguage)}
                    </Typography>
                    <RadioGroup
                      aria-label="SMS alert severity threshold"
                      row
                      name="SMSSeverityThreshold"
                      value={SMSSeverityThreshold}
                      onChange={handleRadioChange}
                    >
                      <FormControlLabel
                        value="high"
                        control={<Radio color="primary" disabled={!SMS} />}
                        label={getTranslation("Only High", preferredLanguage)}
                      />
                      <FormControlLabel
                        value="medium"
                        control={<Radio color="primary" disabled={!SMS} />}
                        label={getTranslation("High & Medium", preferredLanguage)}
                      />
                      <FormControlLabel value="all" control={<Radio color="primary" disabled={!SMS} />} label={getTranslation("All", preferredLanguage)} />
                    </RadioGroup>
                  </Box>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </TabPanel>

        {/* Training Tab */}
        <TabPanel value={value} index={2}>
          {!isLoadingTraining ? (
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper className={classes.sectionCard}>
                  <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                    <Typography className={classes.sectionTitle} style={{ marginBottom: 0 }}>
                      {getTranslation("Training")}
                    </Typography>
                    <Button
                      className={classes.trainingButton}
                      onClick={trainingPush}
                    >
                      {getTranslation("Start Assigning Training", preferredLanguage)}
                    </Button>
                  </Box>

                  <FormGroup>
                    <FormControlLabel
                      control={
                        <Switch
                          color="primary"
                          checked={trainingFlag}
                          onChange={handleTrainingChange}
                          name="trainingFlag"
                        />
                      }
                      label="Training"
                    />

                    {trainingFlag ? (
                      <React.Fragment>
                        <Box mt={3}>
                          <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#0055A2' }} gutterBottom>
                            {getTranslation("Video Style", preferredLanguage)}
                          </Typography>
                          <RadioGroup
                            aria-label="Video type"
                            row
                            name="videoType"
                            value={videoType}
                            onChange={handleTrainingRadioChange}
                          >
                            <FormControlLabel value="A" control={<Radio color="primary" />} label={getTranslation("Anime", preferredLanguage)} />
                            <FormControlLabel value="C" control={<Radio color="primary" />} label={getTranslation("Corporate", preferredLanguage)} />
                          </RadioGroup>
                        </Box>

                        <Box mt={2}>
                          <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#0055A2' }} gutterBottom>
                            {getTranslation("Training Frequency", preferredLanguage)}
                          </Typography>
                          <RadioGroup
                            aria-label="Training frequency"
                            row
                            name="frequency"
                            value={frequency}
                            onChange={handleTrainingRadioChange}
                          >
                            <FormControlLabel value="M" control={<Radio color="primary" />} label={getTranslation("Monthly", preferredLanguage)} />
                            <FormControlLabel value="Q" control={<Radio color="primary" />} label={getTranslation("Quarterly", preferredLanguage)} />
                            <FormControlLabel value="B" control={<Radio color="primary" />} label={getTranslation("Bi-Annually", preferredLanguage)} />
                            <FormControlLabel value="A" control={<Radio color="primary" />} label="Annually" />
                          </RadioGroup>
                        </Box>

                        <Box mt={2}>
                          <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#0055A2' }} gutterBottom>
                            {getTranslation("Requirement", preferredLanguage)}
                          </Typography>
                          <RadioGroup
                            aria-label="Completion requirement"
                            row
                            name="completionIndicator"
                            value={completionIndicator}
                            onChange={handleTrainingRadioChange}
                          >
                            <FormControlLabel value="V" control={<Radio color="primary" />} label={getTranslation("Video watched", preferredLanguage)} />
                            <FormControlLabel value="P" control={<Radio color="primary" />} label={getTranslation("PDF read", preferredLanguage)} />
                            <FormControlLabel value="Q" control={<Radio color="primary" />} label={getTranslation("Quiz taken with a passing score", preferredLanguage)} />
                          </RadioGroup>
                        </Box>

                        <Box mt={3}>
                          <Typography variant="subtitle1" style={{ fontWeight: 600, color: '#0055A2' }} gutterBottom>
                            {getTranslation("Ongoing", preferredLanguage)}
                          </Typography>

                          <Typography variant="subtitle2" gutterBottom style={{ color: '#546e7a' }}>
                            {getTranslation("If user clicked on a yellow link with related training:", preferredLanguage)}
                          </Typography>
                          <RadioGroup
                            aria-label="Yellow click action"
                            row
                            name="yellowClick"
                            value={yellowClick}
                            onChange={handleTrainingRadioChange}
                          >
                            <FormControlLabel value="suggestTrainingYellowClick" control={<Radio color="primary" />} label={getTranslation("Suggest training", preferredLanguage)} />
                            <FormControlLabel value="requireTrainingYellowClick" control={<Radio color="primary" />} label={getTranslation("Require training", preferredLanguage)} />
                            <FormControlLabel value="N" control={<Radio color="primary" />} label={getTranslation("No action", preferredLanguage)} />
                          </RadioGroup>

                          <Box mt={2}>
                            <Typography variant="subtitle2" gutterBottom style={{ color: '#546e7a' }}>
                              {getTranslation("If user clicked on a red link with related training:", preferredLanguage)}
                            </Typography>
                            <RadioGroup
                              aria-label="Red click action"
                              row
                              name="redClick"
                              value={redClick}
                              onChange={handleTrainingRadioChange}
                            >
                              <FormControlLabel value="suggestTrainingRedClick" control={<Radio color="primary" />} label={getTranslation("Suggest training", preferredLanguage)} />
                              <FormControlLabel value="requireTrainingRedClick" control={<Radio color="primary" />} label={getTranslation("Require training", preferredLanguage)} />
                              <FormControlLabel value="N" control={<Radio color="primary" />} label={getTranslation("No action", preferredLanguage)} />
                            </RadioGroup>
                          </Box>
                        </Box>
                      </React.Fragment>
                    ) : null}
                  </FormGroup>
                </Paper>
              </Grid>
            </Grid>
          ) : (
            <span></span>
          )}
        </TabPanel>

        <div id="errorSnackbar" />
      </form>
    </div>
  );
};
export default CompanyConfiguration;
